module.exports = __webpack_public_path__ + "static/img/card.183c3cf8.png";